import { render, staticRenderFns } from "./modal-upload-image.vue?vue&type=template&id=115d6849&scoped=true&"
import script from "./modal-upload-image.vue?vue&type=script&lang=js&"
export * from "./modal-upload-image.vue?vue&type=script&lang=js&"
import style0 from "./modal-upload-image.vue?vue&type=style&index=0&id=115d6849&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115d6849",
  null
  
)

export default component.exports